export const cylinderPredictionFilterOptions = [
  {
    name: "Station",
    value: [["station_id"]],
    label: [["station_name"]],
  },
  {
    name: "Field Technician",
    value: [["fieldTechnician", "id"]],
    label: [["fieldTechnician", "fullName"]],
  },
];
